$(function() {

  var dirRtlFlag = false;
  if ($("html").attr('dir') == 'rtl') {
    dirRtlFlag = true;
  }
  $('#hp-teams').slick({
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    rtl: dirRtlFlag,
    centerMode: true,
    centerPadding: '14%',
    responsive: [{
        breakpoint: 1650,
        settings: {
          centerPadding: '10%',
        }
      }, {
        breakpoint: 1400,
        settings: {
          centerPadding: '10%',
          slidesToShow: 2,
        }
      }, {
        breakpoint: 1250,
        settings: {
          centerPadding: '5%',
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 993,
        settings: {
          centerPadding: '0%',
          slidesToShow: 2,
          centerMode: false,
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0%',
          centerMode: false,
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0%',
          centerMode: false,
        }
      }
    ]
  });

  $('.prev-team').click(function() {
    $('#hp-teams').slick('slickPrev');
    return false;
  });

  $('.next-team').click(function() {
    $('#hp-teams').slick('slickNext');
    return false;
  });


  $('#hp-teams2').slick({
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    rtl: dirRtlFlag,
    centerMode: true,
    centerPadding: '30%',
    responsive: [{
        breakpoint: 1650,
        settings: {
          centerPadding: '10%',
        }
      }, {
        breakpoint: 1400,
        settings: {
          centerPadding: '10%',
          // slidesToShow: 2,
        }
      }, {
        breakpoint: 1250,
        settings: {
          centerPadding: '5%',
          // slidesToShow: 2,
        }
      },
      {
        breakpoint: 993,
        settings: {
          centerPadding: '0%',
          slidesToShow: 2,
          centerMode: false,
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0%',
          centerMode: false,
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0%',
          centerMode: false,
        }
      }
    ]
  });

  $('.prev-team').click(function() {
    $('#hp-teams2').slick('slickPrev');
    return false;
  });

  $('.next-team').click(function() {
    $('#hp-teams2').slick('slickNext');
    return false;
  });


  $('#hp-teams3').slick({
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    rtl: dirRtlFlag,
    centerMode: true,
    centerPadding: '14%',
    responsive: [{
        breakpoint: 1650,
        settings: {
          centerPadding: '10%',
        }
      }, {
        breakpoint: 1400,
        settings: {
          centerPadding: '10%',
          slidesToShow: 2,
        }
      }, {
        breakpoint: 1250,
        settings: {
          centerPadding: '5%',
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 993,
        settings: {
          centerPadding: '0%',
          slidesToShow: 2,
          centerMode: false,
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0%',
          centerMode: false,
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0%',
          centerMode: false,
        }
      }
    ]
  });

  $('.prev-team').click(function() {
    $('#hp-teams3').slick('slickPrev');
    return false;
  });

  $('.next-team').click(function() {
    $('#hp-teams3').slick('slickNext');
    return false;
  });



      $(".hp_numbers").waypoint(function() {

        $({
          blurRadius: 5
        }).animate({
          blurRadius: 0
        }, {
          duration: 2000,
          easing: 'swing',
          step: function() {
            $(".hp_numbers__num").css({
              "-webkit-filter": "blur(" + this.blurRadius + "px)",
              "filter": "blur(" + this.blurRadius + "px)"
            });
          }
        });
        var comma_separator_number_step = $.animateNumber.numberStepFactories.separator(',');
        $(".hp_numbers__num").each(function() {
          var tcount = $(this).data("count");
          $(this).animateNumber({
              number: tcount,
              easing: 'easeInQuad',
              "font-size": "90px",
              numberStep: comma_separator_number_step
            },
            2000);
        });
        this.destroy();
    
      }, {
        offset: '60%'
      });
  

});
